<template>
  <div class="sidepanel">
    <div class="header">
      <BbSkeletonLoader type="list-item-avatar" />
    </div>

    <div class="image-wrapper">
      <BbSkeletonLoader type="image" />
    </div>
    <div class="action-button">
      <BbSkeletonLoader type="text" />
    </div>

    <hr class="divider" />

    <div class="actions">
      <BbSkeletonLoader type="text" />
      <BbSkeletonLoader type="text" />
    </div>

    <div class="metadata-container">
      <BbSkeletonLoader type="text@2" />
      <BbSkeletonLoader type="text@2" />
      <BbSkeletonLoader type="text@2" />
      <BbSkeletonLoader type="text@2" />
      <BbSkeletonLoader type="text@2" />
      <BbSkeletonLoader type="text@2" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'DocumentSkeletonLoader',
};
</script>

<style scoped lang="scss">
* {
  box-sizing: border-box;
}

// need to make the container scrollable when viewport height smaller
@media (max-height: 750px) {
  .sidepanel {
    overflow: auto;
  }
}

.sidepanel {
  @include media-breakpoint-up('sm') {
    display: flex;
  }

  max-height: calc(100vh - 80px);

  // take into consideration the margins
  height: 100%;
  display: none;
  flex-direction: column;
  background-color: $bb-neutral-0;
  border-radius: $bb-spacing-8;
  border: 1px solid #cecdcb;
  box-shadow: 0 0 $bb-spacing-2 0 #0000001a;
  align-items: center;
  min-width: 348px;
  max-width: 348px;

  .divider {
    border: none;
    border-top: 1px solid #cecdcb;
    margin: 0 (-$bb-spacing-4) 0px (-$bb-spacing-4);
    width: 100%;
    background-color: #ccc;
  }

  .v-skeleton-loader {
    background-color: $bb-neutral-0;
    width: 100%;
  }

  .header {
    align-self: flex-start;
    padding: $bb-spacing-4 $bb-spacing-4 $bb-spacing-3 $bb-spacing-4;

    .v-skeleton-loader {
      :deep(.v-skeleton-loader__avatar) {
        min-height: 24px;
        min-width: 24px;
        width: 24px;
        height: 24px;
        margin: 0;
      }

      :deep(.v-skeleton-loader__text) {
        width: 112px;
        margin: 0 0 0 $bb-spacing-2;
      }
    }
  }

  .metadata-container {
    align-self: flex-start;
    margin: 0 $bb-spacing-3;

    .v-skeleton-loader {
      :deep(.v-skeleton-loader__text:nth-child(1)) {
        margin: $bb-spacing-1;
        width: 54px;
        max-width: 54px;
      }

      :deep(.v-skeleton-loader__text:nth-child(2)) {
        width: 112px;
        max-width: 112px;
        margin: $bb-spacing-1;
      }
    }
  }

  .image-wrapper {
    width: 100%;
    min-height: 40%;

    .v-skeleton-loader {
      height: 100%;

      :deep(.v-skeleton-loader__image) {
        height: 100%;
      }
    }
  }

  .action-button {
    width: 100%;

    .v-skeleton-loader {
      :deep(.v-skeleton-loader__text) {
        margin: $bb-spacing-4;
        height: 36px;
        border-radius: 100px;
      }
    }
  }

  .actions {
    width: 100%;
    margin: $bb-spacing-3 0;

    .v-skeleton-loader {
      :deep(.v-skeleton-loader__text) {
        margin: $bb-spacing-1 $bb-spacing-4;
        height: 16px;
        border-radius: 100px;
      }
    }
  }
}
</style>
